const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
  const token = localStorage.getItem('gc_token');
  return token ? { 'Authorization': token } : {};
};

const handleResponse = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) return res.json();
  return res.text();
};

const get = async (path) => {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      ...getAuthHeader()
    }
  });
  return handleResponse(res);
};

const post = async (path, body) => {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      ...getAuthHeader()
    },
    body: JSON.stringify(body ?? {})
  });
  return handleResponse(res);
};

const put = async (path, body) => {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      ...getAuthHeader()
    },
    body: JSON.stringify(body ?? {})
  });
  return handleResponse(res);
};

const del = async (path) => {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'DELETE',
    headers: {
      ...getAuthHeader()
    }
  });
  return handleResponse(res);
};

const getBlob = async (path) => {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'GET',
    headers: {
      ...getAuthHeader()
    }
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  return res.blob();
};

export default { get, post, put, del, getBlob };
export { get, post, put, del, getBlob };
